export class DropdownItemModel {
	readonly label: string;
	readonly onClickCallback: () => void;

	constructor(label: string, onClickCallback: () => void) {
		this.label = label;
		this.onClickCallback = onClickCallback;
	}

	public onClick(): void {
		this.onClickCallback();
	}
}
